import { EmployeeAccess, FormOfAddress, UserRole } from './enums';
import { LocalizedString } from './localized-string';
import { Tag } from './tag';
import { Topic } from './topic';

export interface Employee {
    id: number;
    isMainContact: boolean;
    isBonusContact: boolean;
    isImportContact: boolean;
    hasBonusConditions: boolean;
    lastName: string;
    firstName: string;
    fullName: string;
    email: string;
    phone: string;
    formOfAddress: FormOfAddress;
    position?: Position;
    isLocked: boolean;
    tags?: Tag[];
    roles?: UserRole[];
    /** Whether this employee can get into the portal, and when they last did. */
    access?: EmployeeAccess;
    lastLogin?: string;
    topics?: Topic[];
}

export interface Position {
    id: number;
    name: LocalizedString;
    type: PositionType;
}

export enum PositionType {
    All = 'ALL',
    Customer = 'CUSTOMER',
    Supplier = 'SUPPLIER',
}
